import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { BottomNavigation } from "@mui/material";

const FooterBar = () => {
  return (
    <BottomNavigation
      sx={{
        backgroundColor: "#117CB1",
        position: "fixed",
        bottom: 0,
        zIndex: 1100,
        left: 0,
        width: "100%",
        color: "white",
        textAlign: "center",
        fontSize: { sm: "14px !important" },
      }}
    >
      <Box sx={{ marginTop: { xs: "0px", sm: "6px" } }}>
        <Typography
          sx={{ textAlign: "center", marginTop: "1% !important" }}
          variant="subtitle1"
          component="p"
          fontWeight="500"
        >
          © {new Date().getFullYear()} RioMed Ltd. All Rights Reserved |
          www.riomed.com
        </Typography>
      </Box>
    </BottomNavigation>
  );
};

export default FooterBar;
